import $ from "jquery";
import "jquery-match-height";

$(function () {
  $(window).on("load resize", function () {
    $(".js-matchHeight").matchHeight();
  });
});
/*!
 * jquery-match-height 0.7.2 by @liabru
 * http://brm.io/jquery-match-height/
 * License: MIT
 */
